// extracted by mini-css-extract-plugin
module.exports = {"refundText":"RefundDisplay_refundText__rlgT9"};